import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';
import styles from './styles';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  GridButton,
  GridDateTimePicker,
  GridIconFab,
  GridNumberField,
  GridTextField,
  Placeholder,
  TextField,
} from '../Form/shared';
import { FormBlock } from '../Form';
import { positiveInteger } from '../Form/validators';
import withDeletePopup from '../withDeletePopup';

export const initialTransferValue = {
  first: null,
  business: null,
  economy: null,
  flightNumber: null,
  STD: null,
};

class Transfers extends Component {
  state = {
    expandedTransferPanel: null,
  };

  getTransfers(values, name) {
    const nameParts = name.split('.');
    return nameParts[2]
      ? values[nameParts[0]][nameParts[1]][nameParts[2]]
      : values[nameParts[0]][nameParts[1]];
  }

  handleAddTransferClick = () => {
    const { setFieldValue, values, name } = this.props;
    const transfers = this.getTransfers(values, name);
    setFieldValue(`${name}[${transfers.length}]`, initialTransferValue);
  };

  handleDeleteTransferClick = index => {
    const { setFieldValue, values, name } = this.props;
    const transfers = this.getTransfers(values, name);
    setFieldValue(name, [
      ...transfers.slice(0, index),
      ...transfers.slice(index + 1),
    ]);
    this.setState({ expandedTransferPanel: null });
  };

  handleTransferPanelChange = index => {
    const { expandedTransferPanel } = this.state;
    this.setState({
      expandedTransferPanel: index === expandedTransferPanel ? null : index,
    });
  };

  render() {
    const { classes, values, name, onDeleteConfirmationDialogOpen, t } =
      this.props;
    const { expandedTransferPanel } = this.state;

    const isInbound = name.includes('inbound');

    const transfers = this.getTransfers(values, name);
    return (
      <>
        <FormBlock>
          {transfers.map((transfer, i) => (
            <Accordion
              expanded={expandedTransferPanel === i}
              key={`${name}${i}`}
            >
              <AccordionSummary
                className={classes.innerExpansionSummary}
                expandIcon={
                  <ExpandMoreIcon
                    onClick={this.handleTransferPanelChange.bind(null, i)}
                  />
                }
              >
                <FormBlock>
                  <GridNumberField
                    xs={1}
                    label="F"
                    name={`${name}[${i}].first`}
                    allowedInputValue={positiveInteger}
                  />
                  <GridNumberField
                    xs={1}
                    label="C"
                    name={`${name}[${i}].business`}
                    allowedInputValue={positiveInteger}
                  />
                  <GridNumberField
                    xs={2}
                    label="Y"
                    name={`${name}[${i}].economy`}
                    allowedInputValue={positiveInteger}
                  />
                  <GridTextField
                    xs={3}
                    label="FLT no."
                    name={`${name}[${i}].flightNumber`}
                  />
                  {isInbound ? (
                    <GridDateTimePicker
                      xs={4}
                      label="STD"
                      name={`${name}[${i}].STD`}
                    />
                  ) : (
                    <GridDateTimePicker
                      xs={4}
                      label="STA"
                      name={`${name}[${i}].STA`}
                    />
                  )}
                </FormBlock>
              </AccordionSummary>
              <AccordionDetails className={classes.expansionDetails}>
                <TextField
                  multiline
                  rows="8"
                  variant="outlined"
                  name={`${name}[${i}].paxList`}
                  className={classes.expansionBlock}
                />
                <FormBlock>
                  <Placeholder xs={9} />
                  <GridIconFab
                    className={classes.withTopSpacer}
                    color="secondary"
                    xs={3}
                    icon="delete"
                    onClick={() =>
                      onDeleteConfirmationDialogOpen(
                        this.handleDeleteTransferClick.bind(null, i)
                      )
                    }
                  />
                </FormBlock>
              </AccordionDetails>
            </Accordion>
          ))}
        </FormBlock>
        <FormBlock>
          <Placeholder xs={9} />
          <GridButton
            xs={3}
            variant="contained"
            color="primary"
            label={t('ADD')}
            onClick={this.handleAddTransferClick}
          />
        </FormBlock>
      </>
    );
  }
}

export default withTranslation(withStyles(styles)(withDeletePopup(Transfers)));
